import Title from '../Components/Title';
import { MainLayout } from '../Styles/mainLayouts';
import { useEffect } from 'react';
import styled from 'styled-components';
import profile from '../assets/images/profile.png';
import styles from '../Styles/hoverText.module.css';
import PrimaryButton from '../Components/PrimaryButton';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutPageStyled = styled.div`
    width:98%;
    margin-top: 3.4rem;
    display: flex;
    @media screen and (max-width:1000px){
        flex-direction: column-reverse;
        .left-content{
            margin-bottom: 2rem;
        }
    }
    @media screen and (max-width:600px){
        overflow: hidden;
    }
    .left-content{
        width: 100%;
        display:flex;
        justify-content: right;
    img{
        width: 85%;
        /* margin-left: 66px; */
        height: 80%;
        object-fit: cover;
        }
    }
    .right-content{
        width: 100%;
        h4{
            font-size: 2rem;
            color: var(--white-color);
        span{
            font-size: 2rem;
        }
    }
    .paragraph{
        padding: 1rem 0;
        text-align: justify;
    }
    .about-info{
        display: flex;
        padding-bottom: 1.4rem;
        .info-title{
            padding-right: 3rem;
            p{
                font-weight: 600;
            }
        }
        @media screen and (max-width:600px){
            .info-title{
                padding-right: 0.6rem;
            }
            p{
                font-size: 1rem;
            }
        }
        .info-title, .info{
            p{
                padding: .32rem 0;
            }
        }
    }   
}
`;


const AboutPage = () => {
    useEffect(() => {
        AOS.init({ duration: 2000, })
    }, [])

    const email = "ahsanbeg738@gmail.com"
    const start_email = email.slice(0, 14)
    const end_email = email.slice(14)
    const new_email = <label>{start_email}<br />&nbsp;{end_email}</label>
    const screen_width = window.screen.availWidth

    return (
        <div id="AboutPage">
            <MainLayout>
                <Title title={'About Me'} />
                <AboutPageStyled>
                    <div className="right-content" data-aos="fade-right">
                        <h4>I'm <span>Ahsan Beg</span></h4>
                        <p className="paragraph">
                            I'm a proficient <strong>Full Stack Web Developer</strong> with a huge interest in JavaScript. I built several projects in web development using MERN-STACK. I completed a diploma in Computer Science and Engineering from Government Polytechnic Shahjahanpur in 2019. I also completed Full-Stack Web Development course at <a href="https://masaischool.com" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF' }}>@MasaiSchool</a> and now I'm working as a Full-Stack Developer at <a href="https://registerkaro.in" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF' }}>@RegisterKaro.</a>
                        </p>
                        <div className="about-info">
                            <div className="info-title">
                                <p>Full Name</p>
                                <p>Email</p>
                                {screen_width < 500 ? <br /> : ''}
                                <p>Mobile</p>
                                <p>Languages</p>
                                <p>Location</p>
                                <p>Nationality</p>
                            </div>
                            <div className="info">
                                <p>: Ahsan Beg</p>
                                <p className={styles.tooltip}>:<a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox" target="_blank" rel="noopener noreferrer">&nbsp;{screen_width < 500 ? new_email : email}</a>
                                    <span className={styles.tooltipText}>click to send mail</span>
                                </p>
                                <p className={styles.tooltip}>: <a href="tel:+917355725662">+917355725662</a>
                                    <span className={styles.tooltipText}>click to make call</span>
                                </p>
                                <p>: Hindi, English, Urdu </p>
                                <p>: Khudaganj, Uttar Pradesh</p>
                                <p>: Indian </p>
                            </div>
                        </div>
                        {/* <a href={Ahsan_Beg_Resume} download="Ahsan_Beg_Resume" target="_blank" rel="noopener noreferrer"><PrimaryButton title={'Download Resume'} /></a> */}
                        <a href='https://drive.google.com/file/d/1Gxj9xsePb9WPQSaRXD8oYJlekfAPWtqr/view' target="_blank" rel="noopener noreferrer"><PrimaryButton title={'Resume'} /></a>

                    </div>
                    <div className="left-content" data-aos="fade-left">
                        <img src={profile} alt="" />
                    </div>
                </AboutPageStyled>
            </MainLayout>
        </div>
    )
}
export default AboutPage